import { useCallback } from 'react'
import { useSharedState } from '../components/waxplorer/Waxplorer'

export const reduceTransactionActions = async (actions) =>
    Promise.all(await actions)

export const useTransaction = (
    actions,
    callback,
    options = {
        expireSeconds: 300,
        blocksBehind: 0,
    },
) => {
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    return useCallback(async () => {
        try {
            // store the transaction as a Promise
            const tx = activeUser.session.transact(
                { actions: await reduceTransactionActions(actions) },
                options,
            )

            // the transaction is triggered
            callback(undefined, tx)

            await tx
        } catch (error) {
            callback(error)
        }
    }, [actions, callback])
}

export const useCreateBoostAction = () => {
    const [state] = useSharedState()

    const activeUser = state?.activeUser
    return useCallback(
        async () => ({
            account: 'nft.hive',
            name: 'boost',
            authorization: [
                {
                    actor: await activeUser.accountName,
                    permission: activeUser.requestPermission
                        ? activeUser.requestPermission
                        : 'active',
                },
            ],
            data: {
                booster: activeUser.accountName,
            },
        }),
        [activeUser?.accountName],
    )
}

export const useCreateBurnAction = () => {
    const [state] = useSharedState()

    const activeUser = state?.activeUser
    return useCallback(
        async ({ assetId, contract }) => {
            return contract === 'simpleassets'
                ? {
                      account: 'simpleassets',
                      name: 'burn',
                      authorization: [
                          {
                              actor: await activeUser.accountName,
                              permission: activeUser.requestPermission
                                  ? activeUser.requestPermission
                                  : 'active',
                          },
                      ],
                      data: {
                          owner: activeUser.accountName,
                          memo: '',
                          assetids: [assetId],
                      },
                  }
                : {
                      account: 'atomicassets',
                      name: 'burnasset',
                      authorization: [
                          {
                              actor: await activeUser.accountName,
                              permission: activeUser.requestPermission
                                  ? activeUser.requestPermission
                                  : 'active',
                          },
                      ],
                      data: {
                          asset_owner: activeUser.accountName,
                          asset_id: assetId,
                      },
                  }
        },
        [activeUser?.accountName],
    )
}
